import { find } from "lodash";

const STATUS = [
    {
        label: "All",
        route: "all",
        value: "all"
    },
    {
        label: "Active",
        route: "active",
        value: 1
    },
    {
        label: "Inactive",
        route: "inactive",
        value: 0
    }

];


function checkStatus(data) {
    let checkStatus = find(STATUS, {
        route: String(data)
    });

    if (checkStatus == undefined) {
        checkStatus = STATUS[0];
    }

    return checkStatus;
}

export { STATUS, checkStatus };
